import React, { useEffect, useMemo, useState } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

// Import services for Master Tipe Konten
import {
  fetchTipeKonten,
  createTipeKonten,
  updateTipeKonten,
  deleteTipeKonten
} from '../../../services/Master/MasterTipeKonten'; // Corrected import path/file name

// Import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';

const MasterTipeKonten = () => { // Changed component name
  // Meta title
  document.title = "Master Tipe Konten"; // Updated meta title

  // State management
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  // Renamed state variable from faseUjian to tipeKonten
  const [tipeKonten, setTipeKonten] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [filters, setFilters] = useState({
    tipe_konten: "" // Updated filter field from nama_fase to tipe_konten
  });
  const [deleteModal, setDeleteModal] = useState(false);

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setTipeKonten(null); // Updated state variable
  };

  const handleConfirmDelete = async () => {
    try {
      if (tipeKonten && tipeKonten.id_tipe_konten) { // Updated ID field
        const response = await deleteTipeKonten(tipeKonten.id_tipe_konten); // Updated service call
        if (response.success) {
          toast.success("Tipe Konten berhasil dihapus"); // Updated message
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Gagal menghapus Tipe Konten"); // Updated message
        }
      }
    } catch (error) {
      console.error("Error deleting Tipe Konten:", error); // Updated console log
      toast.error(error.message || "Gagal menghapus Tipe Konten."); // Updated message from error.message
    } finally {
      handleCloseDeleteModal();
    }
  };

  // Fetch data function
  const fetchData = async (page = 1, per_page = 10, filterParams = {}) => {
    try {
      setLoading(true);
      // Updated service call to fetchTipeKonten
      const response = await fetchTipeKonten(page, per_page, filterParams); 

      setData(response.data || []);
      setPagination({
        page: response.meta?.page || 1,
        per_page: response.meta?.per_page || 10,
        total: response.meta?.total || 0,
        last_page: response.meta?.last_page || Math.ceil((response.meta?.total || 0) / (response.meta?.per_page || 10))
      });
    } catch (error) {
      console.error("Error in fetchData:", error); // Updated console log
      toast.error("Gagal memuat data Tipe Konten"); // Updated message
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = {
      ...filters,
      [name]: value
    };
    setFilters(newFilters);
    fetchData(1, pagination.per_page, newFilters); // Pass newFilters directly
  };

  // Clear all filters
  const clearFilters = () => {
    const defaultFilters = {
      tipe_konten: "" // Updated filter field
    };
    setFilters(defaultFilters);
    fetchData(1, pagination.per_page, defaultFilters); // Pass defaultFilters directly
  };

  // Form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      // Updated initial values to use tipe_konten and deskripsi from tipeKonten state
      tipe_konten: tipeKonten?.tipe_konten || "", 
      deskripsi: tipeKonten?.deskripsi || "",
    },

    validationSchema: Yup.object({
      tipe_konten: Yup.string().required("Nama Tipe Konten wajib diisi"), // Updated validation message
      deskripsi: Yup.string().nullable(),
    }),

    onSubmit: async (values) => {
      try {
        // Data is passed as a direct object, not FormData, as per MasterTipeKonten.js service
        let response;
        if (isEdit) {
          // Updated service call to updateTipeKonten with correct ID and values object
          response = await updateTipeKonten(tipeKonten.id_tipe_konten, values); 
        } else {
          // Updated service call to createTipeKonten with values object
          response = await createTipeKonten(values); 
        }

        if (response.success) {
          toast.success(response.message || (isEdit ? "Tipe Konten berhasil diperbarui" : "Tipe Konten berhasil ditambahkan")); // Updated messages
          fetchData(pagination.page, pagination.per_page, filters);
          toggleModal();
        } else {
          if (response.errors) {
            Object.keys(response.errors).forEach(key => {
              response.errors[key].forEach(msg => {
                toast.error(`${key}: ${msg}`);
              });
            });
          } else if (response.code === 409) {
            toast.error(response.message || "Nama Tipe Konten sudah ada. Mohon gunakan nama lain."); // Updated message
          } else {
            toast.error(response.message || "Gagal menyimpan Tipe Konten"); // Updated message
          }
        }
      } catch (error) {
        console.error("Error in form submission:", error); // Updated console log
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.data && error.response.data.errors) {
             Object.keys(error.response.data.errors).forEach(key => {
              error.response.data.errors[key].forEach(msg => {
                toast.error(`${key}: ${msg}`);
              });
            });
        }
        else {
          toast.error("Terjadi kesalahan saat menyimpan data.");
        }
      }
    },
  });

  // Modal handling
  const toggleModal = () => {
    if (modal) {
      setModal(false);
      setTipeKonten(null); // Updated state variable
      setIsEdit(false);
      validation.resetForm();
    } else {
      setModal(true);
    }
  };

  const handleTipeKontenClick = (tipeKontenData) => { // Updated function name and parameter
    setTipeKonten(tipeKontenData); // Updated state variable
    setIsEdit(true);
    toggleModal();
  };

  const onClickDelete = (tipeKontenData) => { // Updated function name and parameter
    setTipeKonten(tipeKontenData); // Updated state variable
    setDeleteModal(true);
  };

  // Table columns
  const columns = useMemo(
    () => [
      {
        header: "Nama Tipe Konten", // Updated header
        accessorKey: "tipe_konten", // Updated accessorKey
        enableColumnFilter: false,
      },
      {
        header: 'Deskripsi',
        accessorKey: "deskripsi",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.getValue() || "-"; // Tampilkan '-' jika deskripsi kosong
        }
      },
      {
        header: 'Created At',
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const rawDate = cellProps.getValue();
          if (rawDate && rawDate !== "0001-01-01T00:00:00Z") {
            const date = new Date(rawDate);
            if (!isNaN(date.getTime())) {
              return date.toISOString().split('T')[0];
            }
          }
          return "-";
        }
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        cell: (cellProps) => (
          <div className="hstack gap-2">
            <Link
              to="#"
              className="btn btn-sm btn-soft-info"
              onClick={() => {
                const tipeKontenData = cellProps.row.original; // Updated variable name
                handleTipeKontenClick(tipeKontenData); // Updated function call
              }}
              id={`edittooltip-${cellProps.row.original.id_tipe_konten}`} // Updated ID
            >
              <i className="mdi mdi-pencil-outline" />
              <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id_tipe_konten}`}>
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="btn btn-sm btn-soft-danger"
              onClick={() => {
                const tipeKontenData = cellProps.row.original; // Updated variable name
                onClickDelete(tipeKontenData); // Updated function call
              }}
              id={`deletetooltip-${cellProps.row.original.id_tipe_konten}`} // Updated ID
            >
              <i className="mdi mdi-delete-outline" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id_tipe_konten}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        )
      },
    ],
    []
  );

  const CustomPagination = () => {
    const { page, last_page, total, per_page } = pagination;

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(last_page, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => fetchData(i, per_page, filters)}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      return pages;
    };

    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="text-muted">
          Menampilkan <span className="fw-semibold">{((page - 1) * per_page) + 1}</span> sampai{' '}
          <span className="fw-semibold">{Math.min(page * per_page, total)}</span> dari total{' '}
          <span className="fw-semibold">{total}</span> entri
        </div>

        <div className="d-flex align-items-center">
          <Pagination className="pagination pagination-rounded mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink
                previous
                onClick={() => page > 1 && fetchData(page - 1, per_page, filters)}
              >
                &lt;
              </PaginationLink>
            </PaginationItem>

            {getPageNumbers()}

            <PaginationItem disabled={page === last_page}>
              <PaginationLink
                next
                onClick={() => page < last_page && fetchData(page + 1, per_page, filters)}
              >
                &gt;
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleConfirmDelete}
        onCloseClick={handleCloseDeleteModal}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master Data" breadcrumbItem="Master Tipe Konten" /> {/* Updated Breadcrumb */}
          {
            loading ? <Spinners setLoading={setLoading} />
              :
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody className="border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 card-title flex-grow-1">List Tipe Konten</h5> {/* Updated title */}
                        <div className="d-flex align-items-center">
                          <Button color="primary" onClick={toggleModal}>
                            <i className="mdi mdi-plus me-1"></i>
                            Tambah
                          </Button>
                        </div>
                      </div>
                    </CardBody>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={data}
                        isGlobalFilter={false}
                        isPagination={false}
                        customPageSize={pagination.per_page}
                        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      />
                      <CustomPagination />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
          }

          {/* Modal for Add/Edit */}
          <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal} tag="h4">
              {!!isEdit ? "Edit Tipe Konten" : "Tambah Tipe Konten"} {/* Updated Modal Title */}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label>Nama Tipe Konten</Label> {/* Updated Label */}
                      <Input
                        name="tipe_konten" // Updated name
                        type="text"
                        placeholder="Nama Tipe Konten" // Updated placeholder
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.tipe_konten || ""} // Updated value
                        invalid={!!(validation.touched.tipe_konten && validation.errors.tipe_konten)} // Updated validation
                      />
                      <FormFeedback>{validation.errors.tipe_konten}</FormFeedback> {/* Updated validation message */}
                    </div>
                    <div className="mb-3">
                      <Label>Deskripsi</Label>
                      <Input
                        name="deskripsi"
                        type="textarea"
                        rows="3"
                        placeholder="Deskripsi (Opsional)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.deskripsi || ""}
                        invalid={!!(validation.touched.deskripsi && validation.errors.deskripsi)}
                      />
                      <FormFeedback>{validation.errors.deskripsi}</FormFeedback>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button color="success" type="submit">
                        {isEdit ? "Update" : "Simpan"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
}

export default MasterTipeKonten;
